<!--  -->
<template>
  <div class="banner-box">
    <div class="head-wrapper">
      <div class="logo-wrapper">
        <img src="../../assets/images/logo.png" alt="logo" />
      </div>
      <div class="nav-wrapper">
        <span
          @click="toArrow(item.tag, item.id)"
          v-for="(item, index) in navInfo"
          :class="[item.tag === activeTag ? 'active' : '']"
          >{{ item.title }}</span
        >
      </div>
    </div>
    <div class="slide-banner" v-if="type == 'swiper'">
      <swiper :listInfo="listInfo" :has-btn="false"></swiper>
    </div>
    <div class="slide-banner" v-if="type == 'poster'">
      <img class="poster" :src="poster" />
    </div>
  </div>
</template>

<script>
import Swiper from "../swiper/swiper.vue";
import Bus from "../../api/bus.js";
import "jquery";
export default {
  data() {
    return {
      navInfo: [
        {
          tag: 0,
          title: "首页",
          id: "#index"
        },
        // {
        //   tag: 1,
        //   title: "产品介绍",
        //   id: "#intelligent-wearable"
        // },
         {
          tag: 1,
          title: "行业资讯",
          id: "#announce-box"
        },
        {
          tag: 2,
          title: "关于我们",
          id: "#about-us"
        },
        // {
        //   tag: 3,
        //   title: "商户入驻",
        //   id: "#merchant-entry"
        // }
      ],
      activeTag: 0,
      logoImg: "../../assets/images/logo.png"
    };
  },

  props: ["type", "listInfo", "poster", "currentTag"],

  watch: {},

  components: {
    swiper: Swiper
  },

  computed: {},

  created() {
    this.activeTag = this.currentTag;
    if (this.$route.name == "Index") {
      const tag = this.$route.params.tag;
      const id = this.$route.params.id;
      if (tag && id) {
        this.activeTag = tag;
        const that = this;
        setTimeout(() => {
          this.activeTag = 0;
          that.toArrow(tag, id);
        }, 500);
      }
    }
  },

  mounted() {
    console.log(this.poster);
    console.log(this.type);
  },

  methods: {
    toArrow: function(tag, id) {
      if( tag == 3 ) {
        if(this.$route.name == "merchantEntry") return false;
        this.$router.push({ name: "merchantEntry"});
        return false
      }
      if (this.$route.name != "Index") {
        this.$router.push({ name: "Index", params: { tag: tag, id: id } });
      } else {
        if (tag != 0) {
          this.activeTag = tag;
          var blog = $(id).offset().top;
          const that = this;
          setTimeout(() => {
            that.activeTag = 0;
          }, 500);
          $("html,body").animate({ scrollTop: blog }, 500);
        }  
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-box {
  width: 100%;
  height: 46vh;
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
  .head-wrapper {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 99;
    margin-top: 43px;
    margin-left: 350px;
    .logo-wrapper {
      float: left;
      width: 173px;
      height: 35px;
      display: flex;
      margin-right: 650px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .nav-wrapper {
      display: flex;
      float: left;
      span {
        display: inline-block\0;
        padding: 5px 25px 7px 25px;
        margin-right: 20px;
        min-width: 110px;
        min-width: 120px\0;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: 600;
        cursor: pointer;
      }
      span:hover {
        font-weight: 900;
        font-size: 22px;
        line-height: 22px;
      }
      .active {
        background: #fff;
        background: linear-gradient(#ffffff, #f5eff0, #ffffff);
        color: #ff789e;
        border-radius: 20px;
        font-weight: 900;
        font-size: 20px;
      }
    }
  }
  .slide-banner {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    .poster {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/banner/banner.vue